import moment from 'moment'
import { utlToLocal } from 'shared/utils/timezone'
import { TimePeriod } from 'entities/areas/model'

export const mergeTimeRanges = (ranges: TimePeriod[]): string => {
    if (!ranges || ranges.length === 0) return ''

    const result: TimePeriod[] = []
    let prev: TimePeriod | null = null

    for (const curr of ranges) {
        if (prev && prev.end === curr.start) {
            prev.end = curr.end
        } else {
            prev = { ...curr }
            result.push(prev)
        }
    }

    return result
        .map((item: any) => {
            return `${utlToLocal(moment(), item.start).format('HH:mm')} - ${utlToLocal(moment(), item.end).format('HH:mm')}`
        })
        .join(', ')
}

export const initialValues = {
    name: '',
    square: '',
    price_per_hour: '',
    prepayment: '',
    photos_hash_names: [],
    equipment: [],
    ad_booking_info: {
        available_booking_time: '',
        available_online_booking_time: '',
        unavailable_refund_period_days: '',
        blocking_before_minutes: '',
        blocking_after_minutes: '',
        minimum_booking_time_minutes: null,
    },
    ad_price_info: {
        more_than_three_hour_price_per_hour: '',
        morning_price_per_hour: '',
        evening_price_per_hour: '',
        morning_hours: '',
        evening_hours: '',
        tariffs: [{ hours: 1, price: 0 }],
    },
}

export type AreaNomenclature = {
    nomenclature_id: number
    name: string
    price: string
    count: number
}

// TODO: Поменять название филдов в форме на camelCase (сейчас они в snake_case)
export const getInitialValues = (data: any) => ({
    name: data.name || '',
    square: data.square || 0,
    price_per_hour: data.price_per_hour || null,
    prepayment: data.prepayment || null,
    equipment: data.nomenclatures
        ? data.nomenclatures.map((item: any) => ({
              nomenclature_id: item.id || 0,
              name: item.name || 1,
              price: item.price || 1,
              count: item.count || 1,
          }))
        : [],
    ad_booking_info: data.ad_booking_info
        ? {
              available_booking_time: data.ad_booking_info
                  .available_booking_time
                  ? mergeTimeRanges(data.ad_booking_info.available_booking_time)
                  : '',
              available_online_booking_time: data.ad_booking_info
                  .available_online_booking_time
                  ? mergeTimeRanges(
                        data.ad_booking_info.available_online_booking_time,
                    )
                  : '',
              unavailable_refund_period_days:
                  data.ad_booking_info.unavailable_refund_period_days || null,
              blocking_before_minutes: data.ad_booking_info
                  .blocking_before_minutes
                  ? data.ad_booking_info.blocking_before_minutes
                  : null,
              blocking_after_minutes: data.ad_booking_info
                  .blocking_after_minutes
                  ? data.ad_booking_info.blocking_after_minutes
                  : null,
              minimum_booking_time_minutes: data.ad_booking_info
                  .minimum_booking_time_minutes
                  ? Number(data.ad_booking_info.minimum_booking_time_minutes) /
                    60
                  : null,
          }
        : null,
    ad_price_info: data.ad_price_info
        ? {
              more_than_three_hour_price_per_hour: data.ad_price_info
                  .more_than_three_hour_price_per_hour
                  ? data.ad_price_info.more_than_three_hour_price_per_hour
                  : null,
              morning_price_per_hour:
                  data.ad_price_info.morning_price_per_hour || null,
              evening_price_per_hour:
                  data.ad_price_info.evening_price_per_hour || null,
              morning_hours: data.ad_price_info.morning_hours
                  ? `${moment.utc(data.ad_price_info.morning_hours.start, 'HH:mm:ss').format('HH:mm')} - ${moment.utc(data.ad_price_info.morning_hours.end, 'HH:mm:ss').format('HH:mm')}`
                  : null,
              evening_hours: data.ad_price_info.evening_hours
                  ? `${moment.utc(data.ad_price_info.evening_hours.start, 'HH:mm:ss').format('HH:mm')} - ${moment.utc(data.ad_price_info.evening_hours.end, 'HH:mm:ss').format('HH:mm')}`
                  : null,
              tariffs: data.ad_price_info?.tariffs || [],
          }
        : null,
    photos: [],
})
